// ./src/components/generic/TireTypeBadge/TireTypeBadge.tsx
import React from "react";
import { Badge, BadgeProps } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { TIRE_TYPE_MAP } from "@/config/tireOptions";

import { AppIcon } from "@/components/generic/AppIcon";

// ============================================
// Types
// ============================================

export interface TireTypeBadgeProps extends Omit<BadgeProps, "color" | "children"> {
  /** Tire type value from the database */
  value: string | null | undefined;

  /** Whether to show the icon */
  showIcon?: boolean;
}

// ============================================
// Component
// ============================================

export const TireTypeBadge: React.FC<TireTypeBadgeProps> = ({
  value,
  showIcon = true,
  size = "sm",
  variant = "light",
  ...rest
}) => {
  const { t } = useTranslation(["tireSets"]);

  const option = value ? TIRE_TYPE_MAP[value] : undefined;

  if (!option) return null;

  return (
    <Badge
      color={option.color}
      variant={variant}
      size={size}
      leftSection={
        showIcon ? <AppIcon iconName={option.icon || ''} size={12} /> : undefined
      }
      {...rest}
    >
      {t(`tireSets:${option.labelKey}`)}
    </Badge>
  );
};

export default TireTypeBadge;